import React from 'react';

const Menu = ({ children }) => <div className="mainmenu">{children}</div>;

export default Menu;
